import { E as EmblaCarousel } from './embla-carousel.esm-DpJzJcqm.js';
import { e as emblaNavigation } from './navigation-DGcbxkcb.js';

class ShopTheLookAlt2 extends HTMLElement {
  #viewport = this.querySelector('.embla__viewport');
  #prevButton = this.querySelector('.slider-button-prev');
  #nextButton = this.querySelector('.slider-button-next');
  /** @type {import('embla-carousel').EmblaCarouselType} */
  #embla;

  connectedCallback() {
    this.#initCarousel();
  }

  disconnectedCallback() {
    this.#embla?.destroy();
  }

  /**
   * Initialize the looping product carousel.
   * Slides-per-view and the mobile edge gutter are driven by CSS in the Liquid
   * markup (slide width classes + container padding).
   */
  #initCarousel() {
    if (!this.#viewport) return;

    this.#embla = EmblaCarousel(this.#viewport, {
      loop: true,
      align: 'start',
      skipSnaps: true,
    });

    if (!this.#prevButton || !this.#nextButton) return;
    emblaNavigation(this.#embla, this.#prevButton, this.#nextButton);
  }
}

customElements.define('shop-the-look-alt-2', ShopTheLookAlt2);
